import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children"]; // import { nanoid } from "@reduxjs/toolkit";
import React // useCallback,
 
// useContext,
// useEffect,
// useRef,
// useState,
from "react";
import InView from "react-intersection-observer"; // interface IntersectContextProps {
//   registerContainer: (e: Element) => void;
//   unregisterContainer: (e: Element) => void;
//   intersecting: string[];
//   intersector?: IntersectionObserver;
// }
// export const IntersectContext = createContext<IntersectContextProps>({
//   registerContainer: () => {},
//   unregisterContainer: () => {},
//   intersecting: [],
//   intersector: undefined,
// });
// interface AnimationProviderContext {
//   children: ReactElement;
// }
// export const AnimationProvider = (props: AnimationProviderContext) => {
//   const [registeredElements, setRegisteredElements] = useState([] as Element[]);
//   const [intersectIds, setIntersectIds] = useState([] as string[]);
//   const [intersectObserver, setIntersectObserver] =
//     useState<IntersectionObserver>();
//   const registerContainer = useCallback(
//     (target: Element) => {
//       setRegisteredElements((elem) => [...elem, target]);
//       intersectObserver?.observe(target);
//     },
//     [intersectObserver]
//   );
//   const unregisterContainer = useCallback(
//     (target: Element) => {
//       setRegisteredElements((elem) => elem.filter((e) => e.id === target.id));
//       intersectObserver?.unobserve(target);
//     },
//     [intersectObserver]
//   );
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (eventEntries) => {
//         const notIntersecting = eventEntries
//           .filter((entry) => !entry.isIntersecting)
//           .map((entry) => entry.target.id);
//         const intersecting = eventEntries
//           .filter((entry) => entry.isIntersecting)
//           .map((entry) => entry.target.id);
//         setIntersectIds((ids) =>
//           ids.filter((id) => !notIntersecting.includes(id))
//         );
//         setIntersectIds((ids) => [...ids, ...intersecting]);
//       },
//       {
//         threshold: 0.1,
//       }
//     );
//     setIntersectObserver(observer);
//     registeredElements.forEach((e) => {
//       observer.observe(e);
//     });
//   }, []);
//   useEffect(() => {
//     const observer = intersectObserver;
//     return () => {
//       observer?.disconnect();
//     };
//   }, [intersectObserver]);
//   return (
//     <IntersectContext.Provider
//       value={{
//         registerContainer,
//         unregisterContainer,
//         intersecting: intersectIds,
//         intersector: intersectObserver,
//       }}
//     >
//       {props.children}
//     </IntersectContext.Provider>
//   );
// };
export var AnimationContainer = function AnimationContainer(_ref) {
    var children = _ref.children, props = _objectWithoutPropertiesLoose(_ref, _excluded); // const intersetor = useContext(IntersectContext);
    // const [animationContainerId] = useState(`animation-container-${nanoid()}`);
    // const ref = useRef<HTMLDivElement>(null);
    // useEffect(() => {
    //   const container = ref.current;
    //   if (!container) return;
    //   intersetor.registerContainer(container);
    //   return () => {
    //     intersetor.unregisterContainer(container);
    //   };
    // }, [ref.current]);
    // const onScreen = intersetor.intersecting.includes(animationContainerId);
    return /*#__PURE__*/ React.createElement(InView, null, function (_ref2) { var inView = _ref2.inView, ref = _ref2.ref; return /*#__PURE__*/ React.createElement("div", Object.assign({}, props, { ref: ref }), children(inView)); });
};
